import React from 'react';
import { Alert, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { createSMTPConfig } from '../../../API/PhishingAPI';
import SMTPSendTestEmailModal from './SMTPSendTestEmailModal';

const blank = () => ({ name: '', from_address: '' });

export class SMTPConfigModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: !!props.open, config: blank(), fromName: '', fromEmail: '', saving: false, error: '', errors: {} };
  }
  componentDidMount() {
    this.mounted = true;
    if (this.state.modal) this.initialize();
  }
  componentWillUnmount() { this.mounted = false; }
  initialize = () => {
    const source = this.props.smtpConfig || {};
    const config = { name: source.name || '', from_address: source.from_address || '', ...(source.id ? { id: source.id } : {}) };
    if (this.props.copiedVersion) delete config.id;
    const match = config.from_address.match(/^\s*(.*?)\s*<([^>]+)>\s*$/);
    this.setState({ config, fromName: match ? match[1].trim().replace(/^"|"$/g, '') : '',
      fromEmail: match ? match[2].trim() : config.from_address.trim(), error: '', errors: {} });
  };
  toggle = () => {
    if (this.pending) return;
    const closing = this.state.modal;
    this.setState({ modal: !closing, saving: false }, () => { if (!closing) this.initialize(); });
    if (closing) this.props.onClose?.();
  };
  change = event => {
    const { name, value, checked, type } = event.target;
    this.setState(current => ({ config: { ...current.config, [name]: type === 'checkbox' ? checked : value } }));
  };
  payload = () => {
    const { fromName, fromEmail, config } = this.state;
    const email = fromEmail.trim();
    // Quote display names containing punctuation before supplying an RFC address.
    const name = fromName.trim();
    return { ...(config.id ? { id: config.id } : {}), managed_profile: true, name: config.name.trim(),
      from_address: name ? `${JSON.stringify(name)} <${email}>` : email };
  };
  save = async () => {
    if (this.pending) return;
    const { config, fromEmail } = this.state, { t } = this.props;
    const errors = {};
    if (!config.name.trim()) errors.name = t('simulation_wizard.required');
    if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(fromEmail.trim()) || /[\r\n]/.test(this.state.fromName)) errors.email = t('simulation_wizard.invalid_email');
    this.setState({ errors, error: '' });
    if (Object.keys(errors).length) return;
    const configToSave = this.payload();
    this.pending = true; this.setState({ saving: true });
    try {
      const result = await createSMTPConfig(configToSave);
      if (!this.mounted) return;
      this.pending = false;
      this.toggle();
      this.props.onSubmit({ ...configToSave, ...result });
    } catch (error) {
      if (this.mounted) this.setState({ error: t('simulation_wizard.smtp_save_error', { message: error.message || '' }) });
    } finally {
      this.pending = false;
      if (this.mounted) this.setState({ saving: false });
    }
  };
  render() {
    const { t } = this.props, { config, saving } = this.state;
    return <>
      {this.props.showOpenButton && <Button color="success" onClick={this.toggle}>{t('smtp_config.actions.create')}</Button>}
      <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" backdrop={saving ? 'static' : true}>
        <ModalHeader toggle={saving ? undefined : this.toggle}>{t(this.props.smtpConfig && !this.props.copiedVersion ? 'simulation_wizard.edit_smtp_title' : 'smtp_config.actions.create')}</ModalHeader>
        <ModalBody>
          {this.props.contextHelp && <div className="alert alert-info" role="note">{this.props.contextHelp}</div>}
          <p className="text-muted">{t('simulation_wizard.smtp_internal_help')}</p>
          {this.state.error && <Alert color="danger" role="alert">{this.state.error}</Alert>}
          <fieldset className="border-0 p-0 m-0" disabled={saving}>
            <FormGroup><Label for="smtp-profile-name">{t('smtp_config.placeholder.name')}</Label>
              <Input id="smtp-profile-name" name="name" value={config.name} onChange={this.change} />
              <small className="text-danger">{this.state.errors.name}</small></FormGroup>
            <Row><Col sm={6}><FormGroup><Label for="smtp-from-name">{t('simulation_wizard.smtp_from_name')}</Label>
              <Input id="smtp-from-name" value={this.state.fromName} onChange={event => this.setState({ fromName: event.target.value })} /></FormGroup></Col>
              <Col sm={6}><FormGroup><Label for="smtp-from-email">{t('simulation_wizard.smtp_from_email')}</Label>
                <Input id="smtp-from-email" aria-describedby="smtp-sender-help" type="email" value={this.state.fromEmail} onChange={event => this.setState({ fromEmail: event.target.value })} />
                <small className="text-danger">{this.state.errors.email}</small></FormGroup></Col></Row>
            <p id="smtp-sender-help" className="text-muted small">{t('simulation_wizard.smtp_sender_help')}</p>
            <SMTPSendTestEmailModal smtpConfig={this.payload()} />
          </fieldset>
        </ModalBody>
        <ModalFooter><Button color="link" disabled={saving} onClick={this.toggle}>{t('smtp_config.actions.cancel')}</Button>
          <Button color="primary" disabled={saving} onClick={this.save}>{saving ? t('simulation_wizard.saving') : this.props.submitLabel || t('smtp_config.actions.submit')}</Button>
        </ModalFooter>
      </Modal>
    </>;
  }
}
SMTPConfigModal.defaultProps = { open: false, showOpenButton: true };
export default withTranslation()(SMTPConfigModal);
